import React from 'react';

const FormContext = React.createContext<Record<string, unknown> | null>(null);

interface FormProviderProps {
  form: Record<string, unknown>;
  children: React.ReactNode;
}

function FormProvider({ form, children }: FormProviderProps) {
  return <FormContext.Provider value={form}>{children}</FormContext.Provider>;
}

FormProvider.displayName = 'FormProvider';
export { FormContext, FormProvider };
